import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppDispatch } from "../../../core/data/redux/store";
import {
    createLeaveType,
    updateLeaveType,
    fetchAllLeaveTypes,
    deleteLeaveType,
} from "../../../core/data/redux/attendance/leaveTypes/LeaveTypeActions";
import { formatDate } from "../../../core/utils/configFormatters";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { all_routes } from "../../router/all_routes";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Drawer, message } from "antd";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";
import { fetchEmployeeLeaveAssignById } from "../../../core/data/redux/attendance/leave/leaveAction";
import { createleaveEncashment, fetchAllleave_Encashment, fetchAllleave_EncashmentBYEmployeeId, UpdateEncashment } from "../../../core/data/redux/attendance/leave_encashment/leave.Action";
import { decryptData } from "../../../core/utils/encryptUtils";

const Leaveencashment = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [tableKey, setTableKey] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<"edit" | "create" | "">("");
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { user } = useSelector((state: any) => state.auth);
    const { leaveTypes, loadingStates } = useSelector((state: any) => state.attendance.leaveTypes);
    const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
    const { employeesbyUser } = useSelector((state: any) => state.employee);
    const employeeId = employeesbyUser?.employeeId;
    const [count, setcount] = useState<any>("")
    const [employeeassignleave, setemployeeassignleave] = useState<any>([])
    const [tabledata, settabledata] = useState<any>([])
    const [errors, setErrors] = useState<any>({});


    useEffect(() => {
        if (user?.UserId) {
            dispatch(getEmployeeByUserId({ userId: user?.UserId }));
        }
    }, [dispatch, employeesbyUser.length, user?.UserId]);

    // Permission
    const encryptedPermissions = localStorage.getItem('currentPermissions');
    const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

    const canAdd =
        permissions.includes("Add") || permissions.includes("AllowAll");
    const canView =
        permissions.includes("View") || permissions.includes("AllowAll");
    const canEdit =
        permissions.includes("Edit") || permissions.includes("AllowAll");
    const canDelete =
        permissions.includes("Delete") || permissions.includes("AllowAll");
    const canExport =
        permissions.includes("Export") || permissions.includes("AllowAll");

    const [formData, setFormData] = useState({
        EmployeeId: employeesbyUser?.employeeId || null,
        LeaveTypeId: "",
        LeavesAvailable: "",
        ActionType: "",
        Remarks: "",
        CreatedBy: user?.UserId
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLeaveTypeChange = (e: any) => {
        const leaveTypeId = e.target.value;

        const selectedLeave = employeeassignleave.find(
            (lt: any) => lt.Id.toString() === leaveTypeId
        );


        setFormData((prev) => ({
            ...prev,
            LeaveTypeId: selectedLeave.LeaveTypeId,
            LeavesAvailable: selectedLeave.LeaveQuantity,
        }));
    };

    useEffect(() => {
        if (employeeId) {
            dispatch(fetchEmployeeLeaveAssignById(employeeId))
                .then((res) => {
                    setemployeeassignleave(res.payload.data)
                })
        }
        if (employeeId) {
            dispatch(fetchAllleave_EncashmentBYEmployeeId(employeeId))
                .then((res) => {
                    settabledata(res.payload.data)
                })
        }
    }, [dispatch, employeeId]);

    const showModal = (type: "edit" | "create") => {
        setModalType(type);
        setIsModalVisible(true);
        setErrors({});
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setModalType("");
        // resetFields();
        setErrors({});
    };

    const handleEditDepartment = (record: any) => {
        setSelectedRowData(record);

        setFormData({
            EmployeeId: employeesbyUser?.employeeId || null,
            LeaveTypeId: record.LeaveType || "",
            LeavesAvailable: record.LeavesAvailable || "",
            ActionType: record.RequestType || "",
            Remarks: record.Remarks || "",
            CreatedBy: user?.UserId || null,
        });
    };



    const validateForm = () => {
        let newErrors: any = {};

        if (!formData.LeaveTypeId) {
            newErrors.LeaveTypeId = "Leave Type is required";
        }
        if (!formData.ActionType) {
            newErrors.ActionType = "Action Type is required";
        }
        if (!formData.LeavesAvailable) {
            newErrors.LeavesAvailable = "Leaves Available is required";
        }

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = () => {
        if (selectedRowData) {
            const Id = selectedRowData?.Id;
            dispatch(UpdateEncashment({ Id: Id, data: formData }))
                .then((res) => {
                    if (res.meta.requestStatus === "fulfilled") {
                        message.success(res.payload.message);
                        dispatch(fetchAllleave_EncashmentBYEmployeeId(employeeId))
                            .then((res) => {
                                settabledata(res.payload.data)
                            })
                        handleCancel()
                    }
                })
        } else {
            dispatch(createleaveEncashment({ data: formData }))
                .then((res) => {
                    if (res.meta.requestStatus === "fulfilled") {
                        message.success(res.payload.message);
                        dispatch(fetchAllleave_EncashmentBYEmployeeId(employeeId))
                            .then((res) => {
                                settabledata(res.payload.data)
                            })
                        handleCancel()
                    }
                })
        }
    };

    const handleDeleteLeaveType = async (leaveTypeId: number) => {
        try {
            const result = await dispatch(deleteLeaveType(leaveTypeId));
            if (result?.meta?.requestStatus === "fulfilled") {
                message.success(result.payload.message);
                setIsDeleteModalVisible(false);
                await dispatch(fetchAllLeaveTypes());
                setTableKey((prevKey) => prevKey + 1);
            } else {
                message.warning(result?.payload?.error);
            }
        } catch (error) {
            message.error("Something went wrong");
        }
    };

    const data = tabledata || [];

    const exportLeaveTypes = data.map((item: any) => ({
        Name: item.Name || "N/A",
        Description: item.Description || "N/A",
        Frequency: item.Frequency || "N/A",
        ProcessDate: item.ProcessDate ? new Date(item.ProcessDate).toLocaleDateString("en-IN") : "N/A",
        Status: item.Status || "Inactive",
        CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
        ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
    }));


    const filteredData = useMemo(() => {
        const filters =
            selectedStatus && selectedStatus !== "All"
                ? { Status: selectedStatus }
                : {};
        return filterData(
            data || [],
            filters,
            "CreatedAt",
            "CreatedAt",
            selectedSort
        );
    }, [data, selectedStatus, selectedSort, tabledata]);

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [selectedStatus, selectedSort, tabledata, data]);

    const config = useAppConfig();
    if (!config) return null;

    const columns = [
        {
            title: "Employee Name",
            dataIndex: "EmployeeName",
            sorter: (a: any, b: any) => a.EmployeeName - b.EmployeeName,
            render: (_: any, record: any) => (
                <div
                    className="d-flex align-items-center"
                    onMouseEnter={(e) => e.currentTarget.querySelector("button")?.style.setProperty("opacity", "1")}
                    onMouseLeave={(e) => e.currentTarget.querySelector("button")?.style.setProperty("opacity", "0")}
                    style={{ gap: 8 }}
                >
                    <span>{record.EmployeeName}</span>
                    <button
                        className="btn btn-link p-0"
                        onClick={() => {
                            if (!canEdit) return;
                            showModal("edit");
                            handleEditDepartment(record);
                        }}
                        disabled={!canEdit}
                        style={{
                            cursor: canEdit ? "pointer" : "not-allowed",
                            opacity: 0, 
                            transition: "opacity 0.3s",
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={!canEdit ? "Permission Denied" : "Edit Department"}
                    >
                        <i className="ti ti-pencil" />
                    </button>
                </div>
            ),
        },
        {
            title: "Leave Type Name",
            dataIndex: "LeaveTypeName",
            sorter: (a: any, b: any) => a.LeaveType.localeCompare(b.LeaveType),
        },
        {
            title: "Leaves Available",
            dataIndex: "LeavesAvailable",
            sorter: (a: any, b: any) => a.LeavesAvailable.localeCompare(b.LeavesAvailable),
        },
        {
            title: "Request Type",
            dataIndex: "RequestType",
            sorter: (a: any, b: any) => a.RequestType.localeCompare(b.RequestType),
        },
        {
            title: "Status",
            dataIndex: "Status",
            render: (text: string) => (
                <span
                    style={{
                        color: text === "Approved" ? "green" : "red",
                        fontWeight: 500,
                    }}
                >
                    {text}
                </span>
            ),
            sorter: (a: any, b: any) => a.Status.localeCompare(b.Status),
        },
        {
            title: "Action",
            dataIndex: "actions",
            render: (text: string, record: any) => (
                <div className="action-icon d-inline-flex">
                    <button
                        className="me-2"
                        onClick={() => {
                            if (!canEdit) return;
                            showModal("edit");
                            handleEditDepartment(record);
                        }}
                        disabled={!canEdit}
                        style={{
                            cursor: canEdit ? "pointer" : "not-allowed",
                            opacity: canEdit ? 1 : 0.5,
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={!canEdit ? "Permission Denied" : "Edit Department"}
                    >
                        <i className="ti ti-edit" />
                    </button>
                    {/* <button
                        onClick={() => {
                            setSelectedRowData(record);
                            setIsDeleteModalVisible(true);
                        }}
                        className="me-2"
                        disabled={record.Status === "inactive"}
                        style={{
                            cursor: record.Status === "inactive" ? "not-allowed" : "pointer",
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Delete"
                    >
                        <i className="ti ti-trash" />
                    </button> */}
                </div>
            ),
        },
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Leave Encashment</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Attendance</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Leave Encashment
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {canExport && (
                                <div className="me-2 mb-2">
                                    <div className="dropdown">
                                        <Link
                                            to="#"
                                            className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-file-export me-1" />
                                            Export
                                        </Link>
                                        <ul className="dropdown-menu  dropdown-menu-end p-3">
                                            <li>
                                                <button
                                                    onClick={() => exportToCSV(exportLeaveTypes, "Encashment")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-pdf me-1" />
                                                    Export as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => exportToExcel(exportLeaveTypes, "Encashment")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as Excel{" "}
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => exportToPDF(exportLeaveTypes, "Encashment")}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as PDF{" "}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                            {canAdd && (
                                <div className="mb-2">
                                    <button
                                        onClick={() => {
                                            showModal("create");
                                        }}
                                        className="btn btn-primary d-flex align-items-center"
                                    >
                                        Add Leave Encashment
                                    </button>
                                </div>
                            )}
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Leave Encashment List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="dropdown me-3">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedStatus
                                            ? selectedStatus.charAt(0).toUpperCase() +
                                            selectedStatus.slice(1)
                                            : "Select Status"}
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedStatus("All")}
                                                className="dropdown-item rounded-1"
                                            >
                                                All
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedStatus("active")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Active
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedStatus("inactive")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Inactive
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedSort
                                            ? `Sort By : ${selectedSort}`
                                            : "Sort By : Last 7 Days"}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Recently Added")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Ascending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Descending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last Month")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last 7 Days")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table
                                key={tableKey}
                                dataSource={filteredData}
                                columns={columns}
                                Selection={true}
                            />
                        </div>
                    </div>
                </div>

                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>

            {/* Modal for Add/Edit Leave Type */}
            <Drawer
                title={modalType === "edit" ? "Edit Leave Encashment" : "Add Leave Encashment"}
                placement="right"
                width={500}
                onClose={handleCancel}
                visible={isModalVisible}
                style={{ marginTop: 50, paddingBottom: 50 }}
            >

                {employeeassignleave?.length > 0 && (
                    <div className="mb-4" style={{ marginTop: "20px" }}>
                        <h5 className="fw-bold mb-3">Leave Details</h5>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>Leave Type</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employeeassignleave?.map((leave: any) => (
                                        <tr key={leave.Id}>
                                            <td>{leave.LeaveTypeName}</td>
                                            <td>{leave.LeaveQuantity}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                <form action="leave-encashment.html">
                    <div className="modal-body pb-0">
                        <div className="row">

                            {/* Leave Type (Dropdown) */}
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Leave Type <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="LeaveTypeId"
                                        className="form-control"
                                        value={formData.LeaveTypeId}
                                        onChange={handleLeaveTypeChange}
                                    >
                                        <option value="">Select Leave Type</option>
                                        {employeeassignleave?.map((lt: any) => (
                                            <option key={lt.Id} value={lt.Id}>
                                                {lt.LeaveTypeName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.LeaveTypeId && (
                                        <div style={{ color: "red" }}>{errors.LeaveTypeId}</div>
                                    )}
                                </div>
                            </div>

                            {/* Leaves Available (auto, readonly) */}
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Leaves Available</label>
                                    <input
                                        type="number"
                                        name="LeavesAvailable"
                                        className="form-control"
                                        value={formData.LeavesAvailable}   // ✅ fixed
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* Action Type */}
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Action <span className="text-danger">*</span>
                                    </label>
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="ActionType"
                                                value="CarryForward"
                                                checked={formData.ActionType === "CarryForward"} // ✅ fixed
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label">Carry Forward</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="ActionType"
                                                value="Encash"
                                                checked={formData.ActionType === "Encash"} // ✅ fixed
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label">Encash</label>
                                        </div>
                                    </div>
                                    {errors.ActionType && (
                                        <div style={{ color: "red" }}>{errors.ActionType}</div>
                                    )}
                                </div>
                            </div>

                            {/* Leaves Requested */}
                            {/* <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Leaves Requested <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="LeavesRequested"
                                        className="form-control"
                                        value={formData.LeavesRequested}  // ✅ fixed
                                        onChange={handleChange}
                                    />
                                    {errors.LeavesRequested && (
                                        <div style={{ color: "red" }}>{errors.LeavesRequested}</div>
                                    )}
                                </div>
                            </div> */}

                            {/* Encash Amount (only if Encash is selected) */}
                            {/* {formData.ActionType === "Encash" && (
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Encash Amount</label>
                                        <input
                                            type="number"
                                            name="EncashAmount"
                                            className="form-control"
                                            value={formData.EncashAmount} 
                                            disabled
                                        />
                                    </div>
                                </div>
                            )} */}

                            {/* Remarks */}
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Remarks</label>
                                    <textarea
                                        name="Remarks"
                                        className="form-control"
                                        value={formData.Remarks}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light me-2"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => handleSubmit()}
                            disabled={isLoading}
                        >
                            {isLoading && (
                                <span className="spinner-border spinner-border-sm me-2" />
                            )}
                            {modalType === "edit" ? "Update Request" : "Submit Request"}
                        </button>
                    </div>
                </form>


            </Drawer>

            {/* Delete Modal */}
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() =>
                    selectedRowData?.Id && handleDeleteLeaveType(selectedRowData.Id)
                }
            />
        </>
    );
};

export default Leaveencashment;
